export var isDev = function isDev() {
  return !isProd();
};
export var isProd = function isProd() {
  try {
    return ["prod", "production", "staging"].includes(process.env.VM_ENV);
  } catch (_unused) {
    return false;
  }
};
export var dataDogEnabled = function dataDogEnabled() {
  var _process$env$DATADOG_;
  return "true" === ((_process$env$DATADOG_ = process.env.DATADOG_ENABLED) === null || _process$env$DATADOG_ === void 0 ? void 0 : _process$env$DATADOG_.toString());
};
export var isBrowser = function isBrowser() {
  return typeof window !== "undefined";
};
export var domainHasWhiskymofo = function domainHasWhiskymofo(url) {
  // eslint-disable-next-line
  var regex = /^https?:\/\/([^\/]*whiskymofo[^\/]*)/i;
  return regex.test(url);
};